import AnnotationVideoPlayer from "./AnnotationVideoPlayer.vue";

export default AnnotationVideoPlayer;
